import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';

import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { UnimplementedRouteComponent } from './unimplemented-route/unimplemented-route.component';
import { ResetPasswordComponent } from './login/reset-password.component';
import { authGuard, loginRedirectGuard } from './services/auth-guard.service';
// import { HomeComponent } from './home.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  // { path: 'home', component: HomeComponent },
  {
    path: 'login',
    canActivate: [loginRedirectGuard],
    component: LoginComponent,
  },
  { path: 'login/callback', component: OktaCallbackComponent },
  { path: 'forgotpassword', component: LoginComponent },
  { path: 'resetpassword', component: ResetPasswordComponent },
  { path: 'register', component: RegisterComponent },
  {
    path: 'admin',
    canActivate: [authGuard],
    data: { roles: ['DfsAdmin', 'DfsOversight'] },
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: 'quoteRequest',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./quote/quote.module').then((m) => m.QuoteModule),
  },
  { path: '**', component: UnimplementedRouteComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
